import { FormNameEnum, isNotNull, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import * as React from 'react'
import { PagedOrgForm } from '../survey/PagedOrgForm'
import { useOrgFormStatus } from '../survey/useOrgFormFields'
import { multiPayGroupInputs } from './MultiPayGroupInputs'

export const MULTI_PAY_GROUPS_FORM_NAME = FormNameEnum.MultiPayGroups
export const MULTI_PAY_GROUPS_FORM_VERSION = 1

export const useMultiPayGroupsFormStatus = (org: OrganizationDetailFragment) => {
  const surveyStatus = useOrgFormStatus(org.id, MULTI_PAY_GROUPS_FORM_NAME, MULTI_PAY_GROUPS_FORM_VERSION)
  if (org.employers.filter(isNotNull).length < 2) return 'complete'
  return surveyStatus
}

export const MultiPayGroupSurvey = () => {
  const returnTo = `locations`
  return (
    <PagedOrgForm
      formName={MULTI_PAY_GROUPS_FORM_NAME}
      formVersion={MULTI_PAY_GROUPS_FORM_VERSION}
      pages={[multiPayGroupInputs]}
      onCompleteReturnTo={returnTo}
    />
  )
}
